import React from "react";
import { graphql } from "gatsby";
import { Reviews } from "@zempler/theme/src/components/reviews/Reviews";

export const TrustpilotReviews = ({ data, ...rest }) => {

  return <Reviews {...data} />;
};

export const TrustpilotReviewsQuery = graphql`
  fragment TrustpilotReviews on UMBRACO_TrustpilotReviewsComponentType {
    heading
    subHeading
    reviews {
      rating
      heading
      review: text
      name: reviewerName
    }
  }
`;


